import { z } from "zod";

import { addressShape } from "@/src/models/address";
import { patientSchema, patientShape, type Patient } from "@/src/models/patient";

// Store only the chart fields displayed by the existing EHR patient card.
const ensuredPatientSnapshotSchema = patientSchema
  .pick({
    givenName: true,
    familyName: true,
    middleName: true,
    dateOfBirth: true,
    gender: true,
    homePhoneNumber: true,
    mobilePhoneNumber: true,
    homeAddress: true,
  })
  .extend({ ehrId: z.string().min(1), secondaryEhrId: z.string().nullable() });

export const ensurePatientOutputSchema = z.object({
  patientEhrId: z.string().min(1),
  /** False when the patient was already linked before this step ran. */
  created: z.boolean(),
  // Optional for historical results and EHR adapters that return only an identifier.
  patient: ensuredPatientSnapshotSchema.optional(),
});

export type EnsurePatientOutput = z.infer<typeof ensurePatientOutputSchema>;

export function ensuredPatientForCard(patient: z.infer<typeof ensuredPatientSnapshotSchema>): Patient {
  return {
    ...patientShape,
    ...patient,
    homeAddress: patient.homeAddress ? { ...addressShape, ...patient.homeAddress } : null,
    notFoundInEhr: false,
  };
}
